<template>
	<slot name="page">
		<slot name="breadcrumb_section" />

		<slot name="main">
			<div class="main">
				<slot name="main_header">
					<div class="main-header">
						<div class="wrapper">
							<slot name="h1" />
						</div>
					</div>
				</slot>

				<slot name="content_layout">
					<div class="main-content">
						<div class="wrapper">
							<div class="cms-content">
								<slot />

								<slot name="share_mobile" />
							</div>

							<slot name="sidebar">
								<aside class="sidebar" :class="{'active': toggleSidebar}">
									<div class="sidebar-title" @click="toggleSidebar = !toggleSidebar"><BaseCmsLabel code="about_us" /></div>
									<BaseCmsNav code="sidebar" v-slot="{items}" data-key="sidebar-nav">
										<ul class="nav-sidebar">
											<li v-for="item in items" :key="item.id">
												<NuxtLink :target="item.target_blank == 1 ? '_blank' : null" :to="item.url_without_domain">{{ item.title }}</NuxtLink>
											</li>
										</ul>
									</BaseCmsNav>
									<div class="support support-sidebar" v-interpolation>
										<div class="support-title"><BaseCmsLabel code="customer_support" /></div>
										<BaseCmsLabel tag="div" code="support" />
										<BaseCmsLabel class="faq-link" tag="div" code="faq" />
									</div>
								</aside>
							</slot>
						</div>
						<slot name="share" />
					</div>
				</slot>
				<slot name="main_extra" />
			</div>
		</slot>

		<slot name="map" />
	</slot>
</template>

<script setup>
	const toggleSidebar = ref(false);
</script>
